import { render, staticRenderFns } from "./IconGoogle.vue?vue&type=template&id=67620b8d&scoped=true&"
import script from "./IconGoogle.vue?vue&type=script&lang=js&"
export * from "./IconGoogle.vue?vue&type=script&lang=js&"
import style0 from "./IconGoogle.vue?vue&type=style&index=0&id=67620b8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67620b8d",
  null
  
)

export default component.exports